
class EventManager {
    private deviceViewUpdatedListeners: DeviceViewUpdatedListener[] = [];
    private latestDeviceMetricsUpdatedListeners: LatestDeviceMetricsUpdatedListener[] = [];
    private deviceMetricSelectedListeners: DeviceMetricSelectedListener[] =[];
    private deviceMetricsSeriesUpdatedListeners: DeviceMetricsSeriesUpdatedListener[] = [];

    public addDeviceViewUpdatedListener(listener: DeviceViewUpdatedListener): void {
        if (this.deviceViewUpdatedListeners.indexOf(listener)>=0) {
            return;
        }
        this.deviceViewUpdatedListeners.push(listener);
    }

    public removeDeviceViewUpdatedListener(listener: DeviceViewUpdatedListener): void {
        let index = this.deviceViewUpdatedListeners.indexOf(listener);
        if (index < 0) {
            return;
        }
        this.deviceViewUpdatedListeners.splice(index, 1);
    }

    public notifyDeviceViewUpdated(deviceView: any): void {
        for(let listener of this.deviceViewUpdatedListeners) {
            listener(deviceView);
        }
    }

    public addLatestDeviceMetricsUpdatedListener(listener: LatestDeviceMetricsUpdatedListener): void {
        if (this.latestDeviceMetricsUpdatedListeners.indexOf(listener)>=0) {
            return;
        }
        this.latestDeviceMetricsUpdatedListeners.push(listener);
    }

    public removeLatestDeviceMetricsUpdatedListener(listener: LatestDeviceMetricsUpdatedListener): void {
        let index = this.latestDeviceMetricsUpdatedListeners.indexOf(listener);
        if (index < 0) {
            return;
        }
        this.latestDeviceMetricsUpdatedListeners.splice(index, 1);
    }

    public notifyLatestDeviceUpdated(latestDeviceMetrics: any): void {
        for(let listener of this.latestDeviceMetricsUpdatedListeners) {
            listener(latestDeviceMetrics);
        }
    }
    
    public addDeviceMetricSelectedListener(listener: DeviceMetricSelectedListener): void {
        if (this.deviceMetricSelectedListeners.indexOf(listener)>=0) {
            return;
        }
        this.deviceMetricSelectedListeners.push(listener);
    }

    public removeDeviceMetricSelectedListener(listener: DeviceMetricSelectedListener): void {
        let index = this.deviceMetricSelectedListeners.indexOf(listener);
        if (index < 0) {
            return;
        }
        this.deviceMetricSelectedListeners.splice(index, 1);
    }

    public notifyDeviceMetricSelected(property: any, selectedDeviceMetric: any): void {
        for(let listener of this.deviceMetricSelectedListeners) {
            listener(property, selectedDeviceMetric);
        }
    }

    public addRealtimeDeviceMetricsSeriesUpdatedListener(listener: DeviceMetricsSeriesUpdatedListener): void {
        if (this.deviceMetricsSeriesUpdatedListeners.indexOf(listener)>=0) {
            return;
        }
        this.deviceMetricsSeriesUpdatedListeners.push(listener);
    }

    public removeRealtimeDeviceMetricsSeriesUpdatedListener(listener: DeviceMetricsSeriesUpdatedListener): void {
        let index = this.deviceMetricsSeriesUpdatedListeners.indexOf(listener);
        if (index < 0) {
            return;
        }
        this.deviceMetricsSeriesUpdatedListeners.splice(index, 1);
    }

    public notifyRealtimeDeviceMetricsSeriesUpdated(deviceMetricsSeriesList: any[]): void {
        for(let listener of this.deviceMetricsSeriesUpdatedListeners) {
            listener(deviceMetricsSeriesList);
        }
    }
    
}

interface DeviceViewUpdatedListener {
    (deviceView: any): void
}

interface LatestDeviceMetricsUpdatedListener {
    (latestDeviceMetrics: any): void
}

interface DeviceMetricSelectedListener {
    (property: any, deviceMetric: any): void
}

interface DeviceMetricsSeriesUpdatedListener {
    (deviceMetricsSeriesList: any[]): void
}

export default EventManager;

